import React from 'react';

export default function Pagination({ toplam, sayfaBasi, sayfaBasiDegistir, aktifSayfa, sayfaDegistir }) {
  const sayfaSayisi = Math.max(1, Math.ceil(toplam / sayfaBasi));
  if (toplam === 0) return null;
  const baslangic = (aktifSayfa - 1) * sayfaBasi + 1;
  const bitis = Math.min(aktifSayfa * sayfaBasi, toplam);
  const sayfalar = [];
  for (let i = 1; i <= sayfaSayisi; i++) {
    if (i === 1 || i === sayfaSayisi || (i >= aktifSayfa - 1 && i <= aktifSayfa + 1)) sayfalar.push(i);
    else if (sayfalar[sayfalar.length - 1] !== '...') sayfalar.push('...');
  }
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between px-8 py-5 border-t border-slate-100 gap-3">
      <div className="flex items-center gap-3 text-[10px] font-black text-slate-400 uppercase tracking-widest">
        <span>{baslangic}–{bitis} / {toplam} kayıt</span>
        <span className="hidden sm:inline text-slate-200">|</span>
        <span className="hidden sm:inline">Sayfa başı:</span>
        {[25, 50, 100].map(n => (
          <button key={n} onClick={() => { sayfaBasiDegistir(n); sayfaDegistir(1); }}
            className={`px-3 py-1 rounded-xl font-black transition-all ${sayfaBasi === n ? 'bg-indigo-600 text-white shadow-lg' : 'text-slate-400 hover:bg-slate-100'}`}>
            {n}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-1">
        <button onClick={() => sayfaDegistir(aktifSayfa - 1)} disabled={aktifSayfa === 1}
          className="w-9 h-9 flex items-center justify-center rounded-xl text-slate-500 hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all font-black">‹</button>
        {sayfalar.map((s, i) =>
          s === '...'
            ? <span key={i} className="w-9 text-center text-slate-300 text-xs font-black">…</span>
            : <button key={s} onClick={() => sayfaDegistir(s)}
              className={`w-9 h-9 flex items-center justify-center rounded-xl text-xs font-black transition-all ${aktifSayfa === s ? 'bg-indigo-600 text-white shadow-lg' : 'text-slate-600 hover:bg-slate-100'}`}>
              {s}
            </button>
        )}
        <button onClick={() => sayfaDegistir(aktifSayfa + 1)} disabled={aktifSayfa === sayfaSayisi}
          className="w-9 h-9 flex items-center justify-center rounded-xl text-slate-500 hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed transition-all font-black">›</button>
      </div>
    </div>
  );
}
